export default "__VITE_ASSET__D3MszXW3__"